import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Button,
  Modal,
  Input,
  Icon,
  Checkbox,
  Collapse,
  Upload,
  Divider,
  Empty,
  message
} from "antd";
const { Panel } = Collapse;
const { Item } = Form;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
import { platformApi } from "../../../../../../api";
import "../index.less";
import { ENDPOINT } from "../../../../../../constants";

const UploadDocuments = ({
  form,
  editable,
  id,
  data,
  fuelLevel,
  setFuelLevel,
  PcheckedList,
  setPCheckedList,
  setPIndeterminate,
  setPCheckAll,
  fileList,
  setFileList,
  RHSfileList,
  setRHSFileList,
  RearfileList,
  setRearFileList,
  LHSfileList,
  setLHSFileList,
  TopfileList,
  setTopFileList,
  additionalFileList,
  setAdditionalFileList,
  FrontForm,
  setFrontForm,
  RHSForm,
  setRHSForm,
  LHSForm,
  setLHSForm,
  RearForm,
  setRearForm,
  TopForm,
  setTopForm,
  frontImg,
  setFront,
  RHSImg,
  setRhs,
  LHSImg,
  setLhs,
  RearImg,
  setRear,
  TopImg,
  setTop,
  setLoading,
  AccidentalDocuments,
  setAccidentalDocuments,
  AdditionalImages,
  setAdditionalImages,
  service,
  batteryNo,
  setBatteryNo,
  batteryDoc,
  setBatteryDoc,
  batteryFileList,
  setBatteryFileList
}) => {
  const { getFieldDecorator, getFieldValue } = form;

  //IMAGES
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [frontVisible, setFrontVisible] = useState(false);

  //CHECKBOX STATES

  // const documents = ["RC", "Insurance", "Pollution", "Service Book"];
  const parts = ["MirrorRH", "MirrorLH", "Toolkit", "FirstAdKit"];

  const getUploadButton = (list) => {
    const isUploading = list && list.length > 0 && list.some(file => file.status === "uploading");
    if (isUploading) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Icon type="loading" style={{ fontSize: "24px", color: "#1890ff", marginBottom: "8px" }} />
          <div className="ant-upload-text" style={{ color: "#1890ff", fontWeight: "500" }}>Uploading...</div>
        </div>
      );
    }
    return (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
  };

  const handleAdditionalImageChange = ({ fileList, file }) => {
    setAdditionalFileList(fileList);

    if (file.status === "uploading") {
      setLoading(true);
      return;
    }

    if (file.status === "done") {
      const originFileObj = file.originFileObj;
      if (!originFileObj) {
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("profile", originFileObj);
      formData.append("master", "Transaction Master");
      formData.append("module", "Job Order");
      formData.append("id", id || "");
      formData.append("type", "additional");

      platformApi
        .post("/api/upload/image", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            setLoading(false);
            const newImage = { url: data.response.data.Location };

            setAdditionalImages((prevImages) => {
              const updatedImages = [...(prevImages || []), newImage];
              if (!data.vehicleImage) {
                data.vehicleImage = {};
              }
              data.vehicleImage.additionalImages = updatedImages;
              return updatedImages;
            });

            setAdditionalFileList([]);
          } else {
            setLoading(false);
            setAdditionalFileList([]);
            message.error("Upload Not Done");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error on Additional Image upload: ", error);
          message.error("Unable to upload image");
          setAdditionalFileList([]);
        });
    }
  };

  const handleChange = ({ fileList, file }, type) => {
    if (type === "Front") setFileList(fileList);
    if (type === "RHS") setRHSFileList(fileList);
    if (type === "Rear") setRearFileList(fileList);
    if (type === "LHS") setLHSFileList(fileList);
    if (type === "Top") setTopFileList(fileList);

    if (file.status === "uploading") {
      setLoading(true);
      return;
    }

    if (file.status === "done" || file.status === "error") {
      if (file.status === "error") {
        setLoading(false);
        message.error("Unable to upload image");
        return;
      }

      const originFileObj = file.originFileObj;
      if (!originFileObj) {
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("profile", originFileObj);
      formData.append("master", "Transaction Master");
      formData.append("module", "Job Order");
      formData.append("id", id || "");

      if (type === "Front") {
        formData.append("type", "front");
        platformApi
          .post("/api/upload/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              setLoading(false);
              setFrontForm(data.response.data.Location);
              setFront(data.response.data.Location);
              setFileList([]);
              message.success("Front View uploaded successfully");
            } else {
              setLoading(false);
              setFileList([]);
              message.error("Upload Not Done");
            }
          })
          .catch((error) => {
            setLoading(false);
            setFileList([]);
            console.error("Error uploading Front View: ", error);
            message.error("Unable to upload image");
          });
      }
      if (type === "RHS") {
        formData.append("type", "rhs");
        platformApi
          .post("/api/upload/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              setLoading(false);
              setRHSForm(data.response.data.Location);
              setRhs(data.response.data.Location);
              setRHSFileList([]);
              message.success("RHS View uploaded successfully");
            } else {
              setLoading(false);
              setRHSFileList([]);
              message.error("Upload Not Done");
            }
          })
          .catch((error) => {
            setLoading(false);
            setRHSFileList([]);
            console.error("Error uploading RHS View: ", error);
            message.error("Unable to upload image");
          });
      }
      if (type === "Rear") {
        formData.append("type", "rear");
        platformApi
          .post("/api/upload/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              setLoading(false);
              setRearForm(data.response.data.Location);
              setRear(data.response.data.Location);
              setRearFileList([]);
              message.success("Rear View uploaded successfully");
            } else {
              setLoading(false);
              setRearFileList([]);
              message.error("Upload Not Done");
            }
          })
          .catch((error) => {
            setLoading(false);
            setRearFileList([]);
            console.error("Error uploading Rear View: ", error);
            message.error("Unable to upload image");
          });
      }
      if (type === "LHS") {
        formData.append("type", "lhs");
        platformApi
          .post("/api/upload/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              setLoading(false);
              setLHSForm(data.response.data.Location);
              setLhs(data.response.data.Location);
              setLHSFileList([]);
              message.success("LHS View uploaded successfully");
            } else {
              setLoading(false);
              setLHSFileList([]);
              message.error("Upload Not Done");
            }
          })
          .catch((error) => {
            setLoading(false);
            setLHSFileList([]);
            console.error("Error uploading LHS View: ", error);
            message.error("Unable to upload image");
          });
      }
      if (type === "Top") {
        formData.append("type", "top");
        platformApi
          .post("/api/upload/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((res) => {
            let { data } = res;
            if (data.code === 200) {
              setLoading(false);
              setTopForm(data.response.data.Location);
              setTop(data.response.data.Location);
              setTopFileList([]);
              message.success("Top View uploaded successfully");
            } else {
              setLoading(false);
              setTopFileList([]);
              message.error("Upload Not Done");
            }
          })
          .catch((error) => {
            setLoading(false);
            setTopFileList([]);
            console.error("Error uploading Top View: ", error);
            message.error("Unable to upload image");
          });
      }
    }
  };

  const getFileIcon = (url) => {
    const extension = url.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return (
          <Icon
            type="file-pdf"
            style={{ fontSize: "40px", color: "#ff4d4f" }}
          />
        );
      case "doc":
      case "docx":
        return (
          <Icon
            type="file-word"
            style={{ fontSize: "40px", color: "#1890ff" }}
          />
        );
      case "xls":
      case "xlsx":
        return (
          <Icon
            type="file-excel"
            style={{ fontSize: "40px", color: "#52c41a" }}
          />
        );
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <img
            src={url}
            alt="Document preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        );
      default:
        return <Icon type="file" style={{ fontSize: "40px" }} />;
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const handleCancel = () => setPreviewVisible(false);
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  // const checkChange = (checked) => {
  //     setCheckedList(checked);
  //     setIndeterminate(!!checked.length && checked.length < checkedList.length);
  //     setCheckAll(checked.length === checkedList.length);
  // };
  const PcheckChange = (checked) => {
    setPCheckedList(checked);
    setPIndeterminate(!!checked.length && checked.length < PcheckedList.length);
    setPCheckAll(checked.length === PcheckedList.length);
  };
  useEffect(() => {
    if (fuelLevel) {
      form.setFieldsValue({
        fuel: fuelLevel ? fuelLevel : "",
      });
    }
  }, [fuelLevel]);

  // Update the useEffect for initialization
  useEffect(() => {
    if (!AdditionalImages) {
      setAdditionalImages([]);
    }
    if (!AccidentalDocuments) {
      setAccidentalDocuments([]);
    }
    // Ensure data.vehicleImage exists and has additionalImages
    if (!data.vehicleImage) {
      data.vehicleImage = {};
    }
    if (!data.vehicleImage.additionalImages) {
      data.vehicleImage.additionalImages = [];
    }
  }, []);

  // Update the useEffect for syncing with parent data
  useEffect(() => {
    if (data && data.vehicleImage && data.vehicleImage.additionalImages) {
      setAdditionalImages(data.vehicleImage.additionalImages);
    }
    if (data && data.accidentalDocuments) {
      setAccidentalDocuments(data.accidentalDocuments);
    }
  }, [data]);

  // Update the delete handler
  const handleDeleteAdditionalImage = (index, image) => {
    setAdditionalImages((prev) => {
      const newImages = prev.filter((_, i) => i !== index);
      // Update parent data
      if (!data.vehicleImage) {
        data.vehicleImage = {};
      }
      data.vehicleImage.additionalImages = newImages;

      platformApi
        .post("/api/upload/deleteFile", { url: image.url })
        .then((res) => {
          console.log("deleted from s3:", res.data.response.message);
        });
      return newImages;
    });
  };

  const handleAccidentalDocumentChange = ({ fileList, file }) => {
    setFileList(fileList);

    if (file.status === "uploading") {
      setLoading(true);
      return;
    }

    if (file.status === "done") {
      const originFileObj = file.originFileObj;
      if (!originFileObj) {
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("profile", originFileObj);
      formData.append("master", "Transaction Master");
      formData.append("module", "Job Order");
      formData.append("id", id || "");
      formData.append("type", "accidental");

      platformApi
        .post("/api/upload/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          let { data: responseData } = res;
          if (responseData.code === 200) {
            setLoading(false);
            const newDocument = { url: responseData.response.data.Location };
            setAccidentalDocuments((prevDocs) => {
              const newDocs = [...(prevDocs || []), newDocument];
              data.accidentalDocuments = newDocs;
              return newDocs;
            });
            setFileList([]);
          } else {
            setLoading(false);
            setFileList([]);
            message.error("Upload Not Done");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error on Accidental Document upload: ", error);
          message.error("Unable to upload document");
          setFileList([]);
        });
    }
  };

  const handleDeleteAccidentalDocument = (index, doc) => {
    setAccidentalDocuments((prev) => {
      const newDocs = prev.filter((_, i) => i !== index);
      data.accidentalDocuments = newDocs;
      return newDocs;
    });
    platformApi.post("/api/upload/deleteFile", { url: doc.url }).then((res) => {
      console.log("deleted from s3:", res.data.response.message);
    });
  };

  const handleDeleteMainImage = (type) => {
    let imageUrl;
    switch (type) {
      case "front":
        imageUrl = frontImg;
        setFront(null);
        setFrontForm("");
        break;
      case "rhs":
        imageUrl = RHSImg;
        setRhs(null);
        setRHSForm("");
        break;
      case "lhs":
        imageUrl = LHSImg;
        setLhs(null);
        setLHSForm("");
        break;
      case "rear":
        imageUrl = RearImg;
        setRear(null);
        setRearForm("");
        break;
      case "top":
        imageUrl = TopImg;
        setTop(null);
        setTopForm("");
        break;
    }

    if (imageUrl) {
      platformApi
        .post("/api/upload/deleteFile", { url: imageUrl })
        .then((res) => {
          console.log("deleted from s3:", res.data.response.message);
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          message.error("Unable to delete image");
        });
    }
  };

  const handleBatteryImageChange = ({ fileList, file }) => {
    if (setBatteryFileList) setBatteryFileList(fileList);

    if (file.status === "uploading") {
      setLoading(true);
      return;
    }

    if (file.status === "done" || file.status === "error") {
      if (file.status === "error") {
        setLoading(false);
        message.error("Unable to upload image");
        return;
      }

      const originFileObj = file.originFileObj;
      if (!originFileObj) {
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("profile", originFileObj);
      formData.append("master", "Transaction Master");
      formData.append("module", "Job Order");
      formData.append("id", id || "");
      formData.append("type", "battery");

      platformApi
        .post("/api/upload/image", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          let { data: responseData } = res;
          if (responseData.code === 200) {
            setLoading(false);
            const location = responseData.response.data.Location;
            const newDoc = { url: location };
            if (setBatteryDoc) setBatteryDoc(newDoc);
            if (data) data.batteryDoc = newDoc;
            if (setBatteryFileList) setBatteryFileList([]);
            message.success("Battery Image uploaded successfully");
          } else {
            setLoading(false);
            if (setBatteryFileList) setBatteryFileList([]);
            message.error("Upload Not Done");
          }
        })
        .catch((error) => {
          setLoading(false);
          if (setBatteryFileList) setBatteryFileList([]);
          console.error("Error uploading Battery Image: ", error);
          message.error("Unable to upload image");
        });
    }
  };

  const handleDeleteBatteryImage = () => {
    const imageUrl = batteryDoc?.url;
    if (setBatteryDoc) setBatteryDoc(null);
    if (data) data.batteryDoc = null;
    if (imageUrl) {
      platformApi
        .post("/api/upload/deleteFile", { url: imageUrl })
        .then((res) => {
          console.log("deleted from s3:", res.data.response?.message);
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          message.error("Unable to delete image");
        });
    }
  };

  return (
    <div className="UploaDocuments">
      <Collapse
        // defaultActiveKey={['1']}
        expandIconPosition="right"
      >
        <Panel header="Optional" key="1">
          {service === "PDI" ? (
            <Form style={{ padding: "10px 20px" }}>
              <Row gutter={24} type="flex" align="middle">
                <Col span={12}>
                  <div style={{ marginBottom: "16px" }}>
                    <div style={{ marginBottom: "8px", fontWeight: "500" }}>Battery Image</div>
                    {editable && (!batteryDoc || !batteryDoc.url) ? (
                      <Upload
                        action={`${ENDPOINT}api/upload/mocky`}
                        listType="picture-card"
                        fileList={batteryFileList}
                        showUploadList={false}
                        onChange={(e) => handleBatteryImageChange(e)}
                        accept=".jpg,.png,.jpeg,.gif"
                        disabled={!editable}
                      >
                        {getUploadButton(batteryFileList)}
                      </Upload>
                    ) : batteryDoc && batteryDoc.url ? (
                      <div className="image-preview-card">
                        <img src={batteryDoc.url} alt="Battery Image" />
                        <div className="hover-overlay">
                          <span
                            className="action-btn view-btn"
                            onClick={() => {
                              setPreviewImage(batteryDoc.url);
                              setPreviewVisible(true);
                            }}
                          >
                            <Icon type="eye" />
                          </span>
                          {editable && (
                            <span
                              className="action-btn delete-btn"
                              onClick={handleDeleteBatteryImage}
                            >
                              <Icon type="delete" />
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <Text type="secondary">No battery image uploaded</Text>
                    )}
                  </div>
                </Col>
                <Col span={12}>
                  <Form.Item colon={false} label={<Text strong>Battery No.</Text>}>
                    {getFieldDecorator("batteryNo", {
                      initialValue: batteryNo,
                    })(
                      <Input
                        disabled={!editable}
                        placeholder="Enter Battery No."
                        onChange={(e) => {
                          if (setBatteryNo) setBatteryNo(e.target.value);
                          if (data) data.batteryNo = e.target.value;
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          ) : (
            <>
              {service=="Accidental" && (
            <>
              <h3>Accidental documents</h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "16px",
                  overflowX: "auto",
                  padding: "8px 0",
                  width: "100%",
                }}
              >
                <Upload
                  action={`${ENDPOINT}api/upload/mocky`}
                  listType="picture-card"
                  fileList={fileList}
                  onChange={(e) =>
                    handleAccidentalDocumentChange(e)
                  }
                  accept=".jpg,.png,.jpeg,.gif,.pdf,.doc,.docx"
                  disabled={!editable}
                  multiple={false}
                  showUploadList={false}
                >
                  {getUploadButton(fileList)}
                </Upload>

                {/* Thumbnails */}
                {AccidentalDocuments &&
                  AccidentalDocuments.length > 0 &&
                  AccidentalDocuments.map((doc, index) => (
                    <div
                      key={index}
                      className="image-preview-card"
                      style={{ flex: "0 0 auto", padding: "10px" }}
                    >
                      {getFileIcon(doc.url)}
                      <div className="hover-overlay">
                        <span
                          className="action-btn view-btn"
                          onClick={() => {
                            const extension = doc.url
                              .split(".")
                              .pop()
                              .toLowerCase();
                            if (
                              ["jpg", "jpeg", "png", "gif"].includes(extension)
                            ) {
                              setPreviewImage(doc.url);
                              setPreviewVisible(true);
                            } else {
                              window.open(doc.url, "_blank");
                            }
                          }}
                        >
                          <Icon type="eye" />
                        </span>
                        {editable && (
                          <span
                            className="action-btn delete-btn"
                            onClick={() =>
                              handleDeleteAccidentalDocument(index, doc)
                            }
                          >
                            <Icon type="delete" />
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "100%" }}>
              <h3>Upload Images:</h3>
              <Form
                style={{
                  marginTop: "4%",
                  marginBottom: "4%",
                  padding: "0px 20px 0px 40px",
                }}
              >
                <Row type="flex" justify="space-around">
                  <Col span={12}>
                    {editable && !frontImg ? (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "8px", fontWeight: "500" }}>Front View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                        <Upload
                          action={`${ENDPOINT}api/upload/mocky`}
                          listType="picture-card"
                          fileList={fileList}
                          showUploadList={false}
                          onChange={(e) => {
                            handleChange(e, "Front");
                          }}
                          accept=".jpg,.png,.jpeg,.gif"
                          disabled={!editable}
                        >
                          {getUploadButton(fileList)}
                        </Upload>
                      </div>
                    ) : (
                      frontImg && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ marginBottom: "8px", fontWeight: "500" }}>Front View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                          <div className="image-preview-card">
                            <img src={frontImg} alt="Front View" />
                            <div className="hover-overlay">
                              <span
                                className="action-btn view-btn"
                                onClick={() => {
                                  setPreviewImage(frontImg);
                                  setPreviewVisible(true);
                                }}
                              >
                                <Icon type="eye" />
                              </span>
                              {editable && (
                                <span
                                  className="action-btn delete-btn"
                                  onClick={() => handleDeleteMainImage("front")}
                                >
                                  <Icon type="delete" />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </Col>
                  <Col span={12}>
                    {editable && !RHSImg ? (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "8px", fontWeight: "500" }}>RHS View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                        <Upload
                          action={`${ENDPOINT}api/upload/mocky`}
                          listType="picture-card"
                          fileList={RHSfileList}
                          showUploadList={false}
                          onChange={(e) => {
                            handleChange(e, "RHS");
                          }}
                          accept=".jpg,.png,.jpeg,.gif"
                          disabled={!editable}
                        >
                          {getUploadButton(RHSfileList)}
                        </Upload>
                      </div>
                    ) : (
                      RHSImg && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ marginBottom: "8px", fontWeight: "500" }}>RHS View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                          <div className="image-preview-card">
                            <img src={RHSImg} alt="RHS View" />
                            <div className="hover-overlay">
                              <span
                                className="action-btn view-btn"
                                onClick={() => {
                                  setPreviewImage(RHSImg);
                                  setPreviewVisible(true);
                                }}
                              >
                                <Icon type="eye" />
                              </span>
                              {editable && (
                                <span
                                  className="action-btn delete-btn"
                                  onClick={() => handleDeleteMainImage("rhs")}
                                >
                                  <Icon type="delete" />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </Col>
                  <Col span={12}>
                    {editable && !RearImg ? (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "8px", fontWeight: "500" }}>Rear View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                        <Upload
                          action={`${ENDPOINT}api/upload/mocky`}
                          listType="picture-card"
                          fileList={RearfileList}
                          showUploadList={false}
                          onChange={(e) => {
                            handleChange(e, "Rear");
                          }}
                          accept=".jpg,.png,.jpeg,.gif"
                          disabled={!editable}
                        >
                          {getUploadButton(RearfileList)}
                        </Upload>
                      </div>
                    ) : (
                      RearImg && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ marginBottom: "8px", fontWeight: "500" }}>Rear View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                          <div className="image-preview-card">
                            <img src={RearImg} alt="Rear View" />
                            <div className="hover-overlay">
                              <span
                                className="action-btn view-btn"
                                onClick={() => {
                                  setPreviewImage(RearImg);
                                  setPreviewVisible(true);
                                }}
                              >
                                <Icon type="eye" />
                              </span>
                              {editable && (
                                <span
                                  className="action-btn delete-btn"
                                  onClick={() => handleDeleteMainImage("rear")}
                                >
                                  <Icon type="delete" />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </Col>
                  <Col span={12}>
                    {editable && !LHSImg ? (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "8px", fontWeight: "500" }}>LHS View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                        <Upload
                          action={`${ENDPOINT}api/upload/mocky`}
                          listType="picture-card"
                          fileList={LHSfileList}
                          showUploadList={false}
                          onChange={(e) => {
                            handleChange(e, "LHS");
                          }}
                          accept=".jpg,.png,.jpeg,.gif"
                          disabled={!editable}
                        >
                          {getUploadButton(LHSfileList)}
                        </Upload>
                      </div>
                    ) : (
                      LHSImg && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ marginBottom: "8px", fontWeight: "500" }}>LHS View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                          <div className="image-preview-card">
                            <img src={LHSImg} alt="LHS View" />
                            <div className="hover-overlay">
                              <span
                                className="action-btn view-btn"
                                onClick={() => {
                                  setPreviewImage(LHSImg);
                                  setPreviewVisible(true);
                                }}
                              >
                                <Icon type="eye" />
                              </span>
                              {editable && (
                                <span
                                  className="action-btn delete-btn"
                                  onClick={() => handleDeleteMainImage("lhs")}
                                >
                                  <Icon type="delete" />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </Col>
                  <Col span={12}>
                    {editable && !TopImg ? (
                      <div style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "8px", fontWeight: "500" }}>Top View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                        <Upload
                          action={`${ENDPOINT}api/upload/mocky`}
                          listType="picture-card"
                          fileList={TopfileList}
                          showUploadList={false}
                          onChange={(e) => {
                            handleChange(e, "Top");
                          }}
                          accept=".jpg,.png,.jpeg,.gif"
                          disabled={!editable}
                        >
                          {getUploadButton(TopfileList)}
                        </Upload>
                      </div>
                    ) : (
                      TopImg && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ marginBottom: "8px", fontWeight: "500" }}>Top View {service === "Accidental" && <span style={{color: 'red'}}>*</span>}</div>
                          <div className="image-preview-card">
                            <img src={TopImg} alt="Top View" />
                            <div className="hover-overlay">
                              <span
                                className="action-btn view-btn"
                                onClick={() => {
                                  setPreviewImage(TopImg);
                                  setPreviewVisible(true);
                                }}
                              >
                                <Icon type="eye" />
                              </span>
                              {editable && (
                                <span
                                  className="action-btn delete-btn"
                                  onClick={() => handleDeleteMainImage("top")}
                                >
                                  <Icon type="delete" />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </Col>
                  <Col span={12}>
                    <div style={{ marginBottom: "16px" }}>
                      <div style={{ marginBottom: "8px", fontWeight: "500" }}>Additional Images</div>
                      <Upload
                        action={`${ENDPOINT}api/upload/mocky`}
                        listType="picture-card"
                        fileList={additionalFileList}
                        onChange={(e) => {
                          handleAdditionalImageChange(e);
                        }}
                        disabled={!editable}
                        multiple={false}
                        showUploadList={false}
                      >
                        {getUploadButton(additionalFileList)}
                      </Upload>
                    </div>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  {AdditionalImages && AdditionalImages.length > 0 && (
                    <div
                      className="additional-images-grid"
                      style={{ marginTop: "20px", width: "100%" }}
                    >
                      <div style={{ marginBottom: "12px", fontWeight: "500" }}>Uploaded Additional Images</div>
                      <Row gutter={[16, 16]}>
                        {AdditionalImages.map((image, index) => (
                          <Col span={12} key={index}>
                            <div className="image-preview-card">
                              <img
                                src={image.url}
                                alt={`Additional ${index + 1}`}
                              />
                              <div className="hover-overlay">
                                <span
                                  className="action-btn view-btn"
                                  onClick={() => {
                                    setPreviewImage(image.url);
                                    setPreviewVisible(true);
                                  }}
                                >
                                  <Icon type="eye" />
                                </span>
                                {editable && (
                                  <span
                                    className="action-btn delete-btn"
                                    onClick={() =>
                                      handleDeleteAdditionalImage(index, image)
                                    }
                                  >
                                    <Icon type="delete" />
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </Row>
              </Form>
            </div>
            <Divider type="vertical" />
            <div style={{ width: "100%" }}>
              <h3>CheckList :</h3>
              <div style={{ padding: "20px" }}>
                <CheckboxGroup
                  options={parts}
                  value={PcheckedList}
                  onChange={PcheckChange}
                  disabled={!editable}
                />
                <br />
                <Row type="flex" justify="space-between">
                  <Col span={12}>
                    <Form.Item colon={false} label={<Text>Fuel Level</Text>}>
                      {getFieldDecorator("fuel", {
                        rules: [
                          {
                            required: false,
                            message: "Please Enter Fuel Level",
                          },
                        ],
                      })(
                        <Input
                          type="number"
                          max="100"
                          onKeyUp={(e) => {
                            if (parseInt(e.target.value) > 100) {
                              form.setFieldsValue({
                                fuel: "100",
                              });
                            } else {
                              form.setFieldsValue({
                                fuel: e.target.value,
                              });
                            }
                          }}
                          disabled={!editable}
                          suffix="%"
                          placeholder="Fuel Level"
                          onChange={(e) => {
                            if (e.target.value) {
                              if (parseInt(e.target.value) > 100) {
                                setFuelLevel(e.target.value);
                              } else {
                                setFuelLevel(e.target.value);
                              }
                            }
                            // setFuelLevel(form.getFieldValue("fuel"))
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
            </>
          )}
        </Panel>
      </Collapse>
      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => {
          setPreviewVisible(false);
          setPreviewImage("");
        }}
        width="40%"
        style={{ top: 20 }}
      >
        <img
          alt="preview"
          style={{ width: "100%" }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};
const WrappedUploadDocuments = Form.create()(UploadDocuments);

export default WrappedUploadDocuments;
